
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vouchers/[voucher_id]",
      function () {
        return require("private-next-pages/vouchers/[voucher_id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vouchers/[voucher_id]"])
      });
    }
  